module.exports = __webpack_public_path__ + "img/ether-outline-white.033c8867.svg";